export const MAX_API_KEYS_PER_USER = 5;
